module.exports = __webpack_public_path__ + "images/rich_heading/other/ticket/icon_2ae136d8468215ffda3ca62ae82a2781.png";